import dayjs from 'dayjs';

export const joinObjectValues = (
    item: Record<string, any>,
    keys: string[],
    divider = ' ',
    fallback = '—'
): string => {
    if (!item || keys.length === 0) return fallback;

    return (
        keys
            .map(key => item?.[key])
            .filter(v => v != null && v !== '') // прибирає null/undefined/пусті строки
            .join(divider) || fallback
    );
};

const dotDatePattern =
    /^(\d{2})\.(\d{2})\.(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/;

const parseDateInput = (value: dayjs.ConfigType) => {
    if (typeof value === 'string') {
        const trimmed = value.trim();
        const match = trimmed.match(dotDatePattern);

        if (match) {
            const [, day, month, year, hour = '0', minute = '0', second = '0'] =
                match;

            return dayjs(
                new Date(
                    Number(year),
                    Number(month) - 1,
                    Number(day),
                    Number(hour),
                    Number(minute),
                    Number(second)
                )
            );
        }
    }

    return dayjs(value);
};

export const formatDateLabel = (
    value?: dayjs.ConfigType,
    fallback = '—'
): string => {
    if (!value) return fallback;
    const date = parseDateInput(value);
    return date.isValid() ? date.format('DD.MM.YYYY') : fallback;
};

export const formatDateTimeLabel = (
    value?: dayjs.ConfigType,
    fallback = '—'
): string => {
    if (!value) return fallback;

    const date = parseDateInput(value);
    return date.isValid() ? date.format('DD.MM.YYYY | HH:mm') : fallback;
};

export const formatFileSize = (
    value?: number | string | null,
    fallback: string = '—'
): string => {
    if (value === undefined || value === null) {
        return fallback;
    }

    const numericValue =
        typeof value === 'string' ? Number.parseFloat(value) : value;

    if (!Number.isFinite(numericValue)) {
        return fallback;
    }

    if (numericValue === 0) {
        return '0 B';
    }

    const units = ['B', 'KB', 'MB', 'GB'];
    const index = Math.min(
        Math.floor(Math.log(numericValue) / Math.log(1024)),
        units.length - 1
    );
    const size = numericValue / Math.pow(1024, index);

    return `${size >= 10 ? size.toFixed(0) : size.toFixed(1)} ${units[index]}`;
};
